import DeviceWidget from "../../FormComponents/DeviceWidget/DeviceWidget";
import {Trans} from "../../utils/i18n";
import React from "react";

export const addressConfig = [
    {
        "name": "private_or_company",
        "size": "half",
        "titel": <Trans i18nKey="appointments.addressContact.private">Private</Trans>,
        "type": "radiobig",
        "value": "private",
        "required": true,
    },
    {
        "name": "private_or_company",
        "size": "half",
        "titel": <Trans i18nKey="appointments.addressContact.company">Company</Trans>,
        "type": "radiobig",
        "value": "company",
        "required": true,
    },
    {
        "name": "first_name",
        "label": <Trans i18nKey="orderEntry.addressContact.firstName">First name</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.firstName">First name</Trans>,
        "size": "half",
        "type": "text",
        "required": true,
        "conditionFunction": (values) => values.private_or_company !== 'company',
    },
    {
        "name": "last_name",
        "label": <Trans i18nKey="orderEntry.addressContact.lastName">Last name</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.lastName">Last name</Trans>,
        "size": "half",
        "type": "text",
        "required": true,
        "conditionFunction": (values) => values.private_or_company !== 'company',
    },
    {
        "name": "name",
        "label": <Trans i18nKey="orderEntry.addressContact.company_name">Company name</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.company_name">Company name</Trans>,
        "size": "full",
        "type": "text",
        "required": true,
        "conditionFunction": (values) => values.private_or_company === 'company',
    },
    {
        "name": "email",
        "label": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.email">E-Mail Address</Trans>,
        "size": "half",
        "type": "email",
        "required": true,
        "validatetype": "api",
        "validationRoute": route("order.validateEmail"),
    },
    {
        "name": "phone",
        "label": <Trans i18nKey="orderEntry.addressContact.phone">Phone</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.phoneNumber">Phone number</Trans>,
        "size": "half",
        "type": "phoneinput",
        "required": true,
    },
    {
        "size": "full",
        "component": "callback",
        "callback": (values) => <>
            <h2><Trans i18nKey={'orderEntry.addressInfo'}>Address info</Trans></h2>
        </>,
    },
    {
        "size": "full",
        "component": "addressautocomplete"
    },
    {
        "name": "zip",
        "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
        "size": "half",
        "required": true,
        "validatetype": "api",
        "validationRoute": route("order.validateZip"),
    },
    {
        "name": "city",
        "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
        "size": "half",
        "required": true,
    },
    {
        "name": "state",
        "label": <Trans i18nKey="orderEntry.addressContact.province">Province</Trans>,
        "size": "full",
        "required": true,
        "conditionFunction": (values, orderEntryState, currentCountry,) => currentCountry === 'IT',
    },
    {
        "name": "country_id",
        "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
        "size": "full",
        "type": "select",
        "options": [
            {
                "value": "de",
                "label": <Trans i18nKey="orderEntry.addressContact.germany">Germany</Trans>
            },
            {
                "value": "ch",
                "label": <Trans i18nKey="orderEntry.addressContact.switzerland">Switzerland</Trans>
            }
        ],
        "required": true,
        "onlyCurrentCountry": true,
    },
];


export const addressConfigWithInvoice = [
    ...addressConfig,
    {
        "name": "deviating_invoice_address",
        "label": <Trans i18nKey="orderEntry.deviating_invoice_address">Different billing address</Trans>,
        "size": "full",
        "type": "checkbox",
    },
    {
        "size": "full",
        "component": "callback",
        "callback": (values) => <>
            <h2><Trans i18nKey={'orderEntry.invoice_address'}>Billing address</Trans></h2>
            <p><Trans i18nKey={'orderEntry.invoice_address.description'}>Please fill in the address that will be displayed on the invoice.</Trans></p>
        </>,
        "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
    },




    {
        "name": "invoice_private_or_company",
        "size": "half",
        "titel": <Trans i18nKey="appointments.addressContact.private">Private</Trans>,
        "type": "radiobig",
        "value": "private",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
    },
    {
        "name": "invoice_private_or_company",
        "size": "half",
        "titel": <Trans i18nKey="appointments.addressContact.company">Company</Trans>,
        "type": "radiobig",
        "value": "company",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
    },
    {
        "name": "invoice_first_name",
        "label": <Trans i18nKey="orderEntry.addressContact.firstName">First name</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.firstName">First name</Trans>,
        "size": "half",
        "type": "text",
        "required": true,
        "conditionFunction": (values) => values.invoice_private_or_company !== 'company' && values.deviating_invoice_address,
    },
    {
        "name": "invoice_last_name",
        "label": <Trans i18nKey="orderEntry.addressContact.lastName">Last name</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.lastName">Last name</Trans>,
        "size": "half",
        "type": "text",
        "required": true,
        "conditionFunction": (values) => values.invoice_private_or_company !== 'company' && values.deviating_invoice_address,
    },
    {
        "name": "invoice_name",
        "label": <Trans i18nKey="orderEntry.addressContact.company_name">Company name</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.company_name">Company name</Trans>,
        "size": "full",
        "type": "text",
        "required": true,
        "conditionFunction": (values) => values.invoice_private_or_company === 'company' && values.deviating_invoice_address,
    },


    {
        "size": "full",
        "component": "addressautocomplete",
        "prefix_name": "invoice_",
        "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
    },
    {
        "name": "invoice_zip",
        "label": <Trans i18nKey="orderEntry.addressContact.zip">ZIP</Trans>,
        "size": "half",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
    },
    {
        "name": "invoice_city",
        "label": <Trans i18nKey="orderEntry.addressContact.city">City</Trans>,
        "size": "half",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
    },
    {
        "name": "invoice_state",
        "label": <Trans i18nKey="orderEntry.addressContact.province">Province</Trans>,
        "size": "full",
        "required": true,
        "conditionFunction": (values, orderEntryState, currentCountry,) => currentCountry === 'IT' && values.deviating_invoice_address,
    },
    {
        "name": "invoice_country_id",
        "label": <Trans i18nKey="orderEntry.addressContact.country">Country</Trans>,
        "placeholder": <Trans i18nKey="orderEntry.addressContact.country.placeholder">Please choose</Trans>,
        "size": "half",
        "type": "select",
        "required": true,
        "conditionFunction": (values, orderEntryState) => values.deviating_invoice_address,
    },
];
